// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__sq-Q3","titleWrapper":"styles_titleWrapper__7pqv3","separatedLine":"styles_separatedLine__zxdHp"};